import hsv_rgb from './hsv-rgb'

export default `${hsv_rgb}
uniform vec3 uBaseColor;
uniform vec2 uResolution;
uniform float uTime;

varying vec2 vUv;
varying vec3 vNormal;
varying vec3 vNormal2;
varying vec3 vPosition;
varying vec3 vWorldPosition;

float getFresnel(vec3 normal, float power) {
  vec3 viewDir = vec3(0.0, -0.5, 1.0);
  return 1.0 - pow(max(dot(viewDir, normal), 0.0), power);
}

void main(){
  vec3 color = vNormal2 * 0.5 + 0.5;
  vec2 fragCoord = gl_FragCoord.xy / uResolution;


  #if defined(MONA_COLOR_BLACK) || !defined(IS_BODY_COLOR)
    color = uBaseColor;
    color = pow(color, vec3(1.0/2.2));
  #endif


  #if defined(MONA_COLOR_PEARL) && defined(IS_BODY_COLOR)
    color = vec3(fragCoord, 1.0);
    float s = sin(fragCoord.x * 3.0 + fragCoord.y * 3.0) * 0.5 + 0.5;

    s *= s;

    vec3 yellow = vec3(250.0/255.0, 255.0/255.0, 171.0/255.0);

    color = mix(color, yellow,  s * 0.5);

    color = pow(color, vec3(1.0/2.2));
  #endif

  #if defined(MONA_COLOR_PURPLE) && defined(IS_BODY_COLOR)

    float topY = smoothstep(1.3, 3.0, vPosition.y);

    // #553ab6
    vec3 topColor1 = vec3(85.0/255.0, 58.0/255.0, 182.0/255.0);
    color = topColor1;
    // #8a90e1
    vec3 topColor2 = vec3(138.0/255.0, 144.0/255.0, 225.0/255.0);
    color = mix(color, topColor2, topY);


  float bottomY = smoothstep(-2.0, -0.2, vPosition.y);
    // bottom color #421782
    vec3 bottomColor = vec3(66.0/255.0, 23.0/255.0, 130.0/255.0);
    color = mix(bottomColor, color, bottomY);
  #endif

  gl_FragColor = vec4(color, 1.0);
}
`
